module.exports = __webpack_public_path__ + "img/_case_info.69d5ebab.svg";